
import { ChevronRight } from "lucide-react";
import React from "react";

const terms = [
  "The charges for the services and the application fee for the Dubai visa are not reversible in any way. Note that the total fee is non-refundable when you apply for the visa even if your Dubai visa application is rejected.",
  "We cannot control the situations when a visa application will be either approved or denied, as well as the time it will take for processing.",
  "The normal Dubai visa application processing time may be affected; the immigration department is solely in charge of this.",
  "In some circumstances, it is Immigration or uberevisa.com may require more papers.",
  "Certain prices mentioned in this guide may have changed at the time of publication; therefore, prices are subject to change without prior notice.",
  "Visa applications will only be processed once all the documentation required has been produced, and the full amount paid.",
  "Any Dubai visa issued for a visit, business, transit, or tourism, does not permit a person to work in the country of visitation.",
  "uberevisa.com reserves the right to decline applications as deemed fit and will not be held liable for the immigration department's time hand or refusal of visa applications.",
  "In as much as the destination country may charge any fee, it is up to the traveler or the consumer to cater to the fees on their own.",
  "The applicant will have to bear the incidental charges like courier charges of documents, development of photographs, attestations etc.",
  "Visa fees are subject to variation depending on the applicant's nationality.",
];

export function TermsAndConditions() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold">Dubai Visa Services - Terms & Conditions</h2>
      </div>
      <ul className="space-y-4">
        {terms.map((term, index) => (
          <li key={index} className="flex items-start">
            <ChevronRight size={20} className="text-primary mr-2 mt-1 flex-shrink-0" />
            <span className="text-neutral-600">{term}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
